import { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { Toaster } from '@/components/ui/sonner'
import GeneralError from '@/modules/errors/general-error'
import NotFoundError from '@/modules/errors/not-found-error'
import { Loader2 } from 'lucide-react'

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient
}>()({
  component: () => {
    return (
      <>
        <Outlet />
        <Toaster />
        {import.meta.env.MODE === 'development' && (
          <>
          </>
        )}
      </>
    )
  },
  pendingComponent: () => (
    <div className="flex h-svh w-full items-center justify-center">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  ),
  notFoundComponent: NotFoundError,
  errorComponent: GeneralError,
})
